<template>
  <section class="address-lists p-3 bg-white box-shaddow20 border-r-10">
    <div class="d-flex align-items-center justify-content-between pb-4">
      <div class="d-flex align-items-center gap-5 custom-border-right px-2">
        <AddressIcon />
        <h4 class="font-w-400 font-s-18 text-color-theme-dark m-0">
          لیست آدرس ها
        </h4>
      </div>
      <button
        class="custom-btn"
        data-toggle="modal"
        data-target="#AddAddress1"
        @click="newAddress"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 17.0625C4.5525 17.0625 0.9375 13.4475 0.9375 9C0.9375 4.5525 4.5525 0.9375 9 0.9375C13.4475 0.9375 17.0625 4.5525 17.0625 9C17.0625 13.4475 13.4475 17.0625 9 17.0625ZM9 2.0625C5.175 2.0625 2.0625 5.175 2.0625 9C2.0625 12.825 5.175 15.9375 9 15.9375C12.825 15.9375 15.9375 12.825 15.9375 9C15.9375 5.175 12.825 2.0625 9 2.0625Z"
            fill="white"
          />
          <path
            d="M12 9.5625H6C5.6925 9.5625 5.4375 9.3075 5.4375 9C5.4375 8.6925 5.6925 8.4375 6 8.4375H12C12.3075 8.4375 12.5625 8.6925 12.5625 9C12.5625 9.3075 12.3075 9.5625 12 9.5625Z"
            fill="white"
          />
          <path
            d="M9 12.5625C8.6925 12.5625 8.4375 12.3075 8.4375 12V6C8.4375 5.6925 8.6925 5.4375 9 5.4375C9.3075 5.4375 9.5625 5.6925 9.5625 6V12C9.5625 12.3075 9.3075 12.5625 9 12.5625Z"
            fill="white"
          />
        </svg>
        <span class="pr-1">افزودن آدرس جدید</span>
      </button>
    </div>
    <div>
      <div class="address-list-grid py-3 text-center border-bottom">
        <span class="font-w-500 font-s-15 text-color-theme-grey1">شناسه</span>
        <span class="font-w-500 font-s-15 text-color-theme-grey1"
          >تحویل گیرنده</span
        >
        <span class="font-w-500 font-s-15 text-color-theme-grey1">آدرس</span>
        <span class="font-w-500 font-s-15 text-color-theme-grey1">عملیات</span>
      </div>
      <div>
        <div
          v-if="addresses == null || addresses == ''"
          class="text-center py-5"
        >
          <svg
            width="65"
            height="65"
            viewBox="0 0 65 65"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M32.4998 38.3768C26.7311 38.3768 22.0186 33.6914 22.0186 27.8956C22.0186 22.0997 26.7311 17.4414 32.4998 17.4414C38.2686 17.4414 42.9811 22.1268 42.9811 27.9227C42.9811 33.7185 38.2686 38.3768 32.4998 38.3768ZM32.4998 21.5039C28.979 21.5039 26.0811 24.3747 26.0811 27.9227C26.0811 31.4706 28.9519 34.3414 32.4998 34.3414C36.0477 34.3414 38.9186 31.4706 38.9186 27.9227C38.9186 24.3747 36.0206 21.5039 32.4998 21.5039Z"
              fill="#C4C1C1"
            />
            <path
              d="M32.4996 61.642C28.4912 61.642 24.4558 60.1253 21.3141 57.1191C13.3246 49.4274 4.4954 37.1587 7.82665 22.5607C10.8329 9.31699 22.3975 3.38574 32.4996 3.38574C32.4996 3.38574 32.4996 3.38574 32.5266 3.38574C42.6287 3.38574 54.1933 9.31699 57.1996 22.5878C60.5037 37.1857 51.6746 49.4274 43.685 57.1191C40.5433 60.1253 36.5079 61.642 32.4996 61.642ZM32.4996 7.44824C24.6183 7.44824 14.4891 11.6462 11.8079 23.4545C8.8829 36.2107 16.8996 47.2066 24.1579 54.167C28.8433 58.6899 36.1829 58.6899 40.8683 54.167C48.0996 47.2066 56.1162 36.2107 53.2454 23.4545C50.5371 11.6462 40.3808 7.44824 32.4996 7.44824Z"
              fill="#C4C1C1"
            />
          </svg>

          <h5 class="font-w-500 font-s-18 text-color-theme-grey2">
            آدرسی وجود ندارد
          </h5>
        </div>
        <template v-else>
          <article
            v-for="address in addresses"
            :key="address.id"
            class="address-list-grid py-3 px-2 mb-2 text-center fontsize-mini text-color-666 border-bottom"
          >
            <span class="font-w-400 font-s-14 text-color-theme-dark">
              {{ address.id }}</span
            >
            <span class="font-w-400 font-s-14 text-color-theme-dark"
              >{{ address.first_name }} {{ address.last_name }}</span
            >
            <span class="font-w-400 font-s-14 text-color-theme-dark">
              {{
                address.city && address.city.province
                  ? address.city.province.name + " - "
                  : ""
              }}
              {{ address.city ? address.city.name + " - " : "" }}
              {{ address.address }}
            </span>
            <span>
              <button class="ml-2 bg-none" @click="editAddress(address)">
                <svg
                  width="23"
                  height="23"
                  viewBox="0 0 23 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.9497 20.5993H3.57018C3.19709 20.5993 2.8877 20.2899 2.8877 19.9169C2.8877 19.5438 3.19709 19.2344 3.57018 19.2344H19.9497C20.3228 19.2344 20.6322 19.5438 20.6322 19.9169C20.6322 20.2899 20.3228 20.5993 19.9497 20.5993Z"
                    fill="#147CFE"
                  />
                  <path
                    d="M18.1469 3.7464C16.3816 1.98105 14.6526 1.93555 12.8418 3.7464L11.7407 4.84748C11.6497 4.93847 11.6133 5.08407 11.6497 5.21147C12.3413 7.6229 14.2704 9.55205 16.6819 10.2436C16.7183 10.2527 16.7547 10.2618 16.7911 10.2618C16.8912 10.2618 16.9821 10.2254 17.0549 10.1526L18.1469 9.05156C19.0478 8.15979 19.4846 7.29531 19.4846 6.42173C19.4937 5.52086 19.0569 4.64728 18.1469 3.7464Z"
                    fill="#147CFE"
                  />
                  <path
                    d="M15.045 11.0716C14.7811 10.9442 14.5263 10.8168 14.2806 10.6712C14.0804 10.5529 13.8893 10.4255 13.6982 10.289C13.5435 10.189 13.3615 10.0434 13.1886 9.89776C13.1704 9.88866 13.1067 9.83406 13.0339 9.76126C12.7336 9.50647 12.3969 9.17888 12.0966 8.81489C12.0693 8.79669 12.0238 8.73299 11.9601 8.65109C11.8691 8.5419 11.7144 8.3599 11.578 8.15061C11.4688 8.01411 11.3414 7.81391 11.2231 7.61372C11.0775 7.36803 10.9501 7.12233 10.8227 6.86754C10.8034 6.82623 10.7847 6.78513 10.7667 6.74427C10.6324 6.44096 10.2369 6.35229 10.0023 6.58684L4.78953 11.7996C4.67124 11.9179 4.56204 12.1454 4.53474 12.3001L4.04335 15.7853C3.95236 16.4041 4.12525 16.9865 4.50744 17.3778C4.83503 17.6963 5.29002 17.8691 5.78141 17.8691C5.8906 17.8691 5.9998 17.86 6.109 17.8418L9.60331 17.3505C9.7671 17.3232 9.9946 17.214 10.1038 17.0957L15.31 11.8894C15.5462 11.6532 15.4571 11.2479 15.1499 11.1168C15.1153 11.102 15.0804 11.087 15.045 11.0716Z"
                    fill="#147CFE"
                  />
                </svg>
              </button>
              <button
                class="bg-none"
                @click="deleteAddress(address.id)"
                :disabled="disabled"
              >
                <svg
                  width="22"
                  height="23"
                  viewBox="0 0 22 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.1729 5.33948C17.7079 5.19388 16.2428 5.08468 14.7687 5.00279V4.99369L14.5685 3.81072C14.432 2.97354 14.2318 1.71777 12.1024 1.71777H9.7183C7.59805 1.71777 7.39786 2.91894 7.25226 3.80162L7.06117 4.96639C6.21489 5.02099 5.36861 5.07558 4.52233 5.15748L2.66598 5.33948C2.28379 5.37588 2.0108 5.71257 2.0472 6.08566C2.0836 6.45875 2.41119 6.73174 2.79338 6.69534L4.64973 6.51335C9.418 6.04016 14.2227 6.22215 19.0455 6.70444C19.0728 6.70444 19.091 6.70444 19.1183 6.70444C19.4641 6.70444 19.7644 6.44055 19.8008 6.08566C19.8281 5.71257 19.5551 5.37588 19.1729 5.33948Z"
                    fill="#EA3532"
                  />
                  <path
                    d="M17.4988 7.9877C17.2804 7.76021 16.9801 7.63281 16.6707 7.63281H5.1686C4.85921 7.63281 4.54982 7.76021 4.34052 7.9877C4.13123 8.2152 4.01293 8.52459 4.03113 8.84308L4.59532 18.1794C4.69541 19.5626 4.82281 21.2916 7.99863 21.2916H13.8407C17.0165 21.2916 17.1439 19.5717 17.244 18.1794L17.8082 8.85218C17.8264 8.52459 17.7081 8.2152 17.4988 7.9877ZM12.4302 16.7326H9.39999C9.0269 16.7326 8.71751 16.4232 8.71751 16.0501C8.71751 15.677 9.0269 15.3676 9.39999 15.3676H12.4302C12.8033 15.3676 13.1127 15.677 13.1127 16.0501C13.1127 16.4232 12.8033 16.7326 12.4302 16.7326ZM13.1946 13.0927H8.64471C8.27162 13.0927 7.96223 12.7833 7.96223 12.4102C7.96223 12.0371 8.27162 11.7277 8.64471 11.7277H13.1946C13.5677 11.7277 13.8771 12.0371 13.8771 12.4102C13.8771 12.7833 13.5677 13.0927 13.1946 13.0927Z"
                    fill="#EA3532"
                  />
                </svg>
              </button>
            </span>
          </article>
        </template>
      </div>
    </div>
    <address-modal
      @new-address="addNewAddress"
      :mode="mode"
      v-model="address"
    ></address-modal>
  </section>
</template>
<script>
import AddressModal from "@/parts/Front/components/AddressModal";
import AddressIcon from "@/parts/Front/components/Icon/panelIcons/Address.vue";
export default {
  components: {
    AddressModal,
    AddressIcon,
  },
  props: { tab: { Number } },
  data() {
    return {
      mode: "create",
      disabled: false,
      address: {},
    };
  },
  created() {
    if (this.$store.getters["front/getProvincesData"] == null) {
      this.$store.dispatch("front/getProvincesDataFromServer");
    }
  },
  mounted() {
    if (this.provinces == null) {
      this.$store.dispatch("front/getProvincesDataFromServer");
    }
  },
  computed: {
    addresses() {
      if (
        this.$store.getters["front/getHomeData"] != null &&
        this.$store.getters["front/getHomeData"].user.user != ""
      ) {
        return this.$store.getters["front/getHomeData"].user.user.addresses;
      } else {
        return null;
      }
    },
    provinces() {
      return this.$store.getters["front/getProvincesData"];
    },
  },
  methods: {
    addNewAddress(newAddress) {
      if (this.mode == "create") {
        this.$store.commit("front/newAddress", newAddress);
      } else {
        this.$store.commit("front/editAddress", newAddress);
      }
    },
    newAddress() {
      this.address = {
        province: null,
        city: null,
        first_name: "",
        last_name: "",
        postal_code: "",
        address: "",
        mobile: "",
      };
      this.mode = "create";
    },
    async deleteAddress(id) {
      this.disabled = true;
      try {
        const response = await this.$store.dispatch("front/deleteAddress", {
          id,
        });
        if (response) {
          this.$root.notify(response.data.message, "success");
          this.$store.commit("front/deleteAddress", id);
        }
      } catch (error) {
        this.$root.notify(error);
      }
      this.disabled = false;
    },
    async editAddress(item) {
      let address = { ...item };
      address.province = address.city.province;
      this.address = address;
      this.mode = "edit";
      window.$("#AddAddress1").modal("show");
    },
  },
};
</script>
<style scoped>
.address-list-grid {
  display: grid;
  grid-template-columns: 50px 1fr 2fr 60px;
  grid-gap: 15px;
}
</style>
